'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMessagesUtk = undefined;

var _set = require('transmute/set');

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setMessagesUtk = exports.setMessagesUtk = (0, _set2.default)('messagesUtk');